import { useMutation } from '@gogame/query';

import { generateLinks } from 'scenes/Campaigns/sources/links';

import { generateCMNLinks } from '../queryKeyFactory';

export const useGenerateLinks = () => {
  const generateCMNLinksMutation = useMutation(
    generateCMNLinks(),
    generateLinks
  );

  const handleAction = async (params) => {
    await generateCMNLinksMutation.mutateAsync(params);
  };

  return [handleAction, generateCMNLinksMutation];
};
